import { deepFreeze } from '../../../utils/objectUtils';

/**
 * Define Ad IDs
 *
 * For ad formats that are always the same for all breakpoints, use a string or
 * array of strings:
 * @example
 * dynamic_package: 'medium_rectangle',
 * search_side: ['medium_rectangle', 'half_page']
 *
 * For ad formats that change per breakpoint, use an object:
 * @example
 * article_between_paragraphs: {
 *   mobile: 'medium_rectangle',
 *   tablet: 'medium_rectangle'
 * }
 */
export const adIds = deepFreeze({
  // article
  article: {
    mobile: ['medium_rectangle', 'half_page'],
    tablet: ['medium_rectangle', 'half_page']
  },
  article_side: {
    small_desktop: ['medium_rectangle', 'half_page'],
    large_desktop: ['medium_rectangle', 'half_page']
  },
  article_footer: {
    small_desktop: ['billboard', 'pushdown'],
    large_desktop: ['billboard', 'pushdown']
  },

  // content package
  content_package_right: 'medium_rectangle',
  content_package_right_with_tablet_full_width: {
    mobile: 'medium_rectangle',
    tablet: 'leaderboard',
    small_desktop: 'medium_rectangle',
    large_desktop: 'medium_rectangle'
  },
  content_package_right_tall: {
    mobile: 'medium_rectangle',
    tablet: 'medium_rectangle',
    small_desktop: 'half_page',
    large_desktop: 'half_page'
  },
  content_package_tablet: { tablet: 'leaderboard' },
  content_package_bottom: {
    mobile: 'medium_rectangle',
    tablet: 'leaderboard',
    small_desktop: 'billboard',
    large_desktop: 'billboard'
  },

  // dynamic package
  dynamic_package: 'medium_rectangle',

  // gallery
  gallery_inline: {
    mobile: 'medium_rectangle',
    tablet: 'medium_rectangle'
  },
  gallery_inline_last: {
    mobile: 'medium_rectangle',
    tablet: 'medium_rectangle'
  },
  gallery_side: {
    small_desktop: ['medium_rectangle', 'half_page'],
    large_desktop: ['medium_rectangle', 'half_page']
  },

  // header
  header: {
    mobile: 'mobile_static_banner',
    tablet: 'top_placement_tablet',
    small_desktop: ['billboard', 'top_placement_small_desktop', 'pushdown'],
    large_desktop: ['billboard', 'top_placement_large_desktop', 'pushdown']
  },

  // high volume hero package
  high_volume_hero_package: 'medium_rectangle',

  // homepage
  homepage: {
    mobile: ['medium_rectangle', 'half_page'],
    tablet: 'leaderboard',
    small_desktop: ['billboard', 'pushdown'],
    large_desktop: ['billboard', 'pushdown']
  },

  // hub page
  hub_page_embed: { tablet: 'leaderboard' },
  hub_page_embed_sticky: {
    small_desktop: ['medium_rectangle', 'half_page'],
    large_desktop: ['medium_rectangle', 'half_page']
  },
  hub_page_embed_grid: {
    mobile: 'medium_rectangle',
    tablet: 'medium_rectangle'
  },
  hub_bottom: {
    small_desktop: ['billboard', 'pushdown'],
    large_desktop: ['billboard', 'pushdown']
  },

  // left package
  left_package: 'medium_rectangle',

  // left right package
  left_right_package_mobile: {
    mobile: 'medium_rectangle'
  },
  left_right_package_non_mobile: {
    tablet: 'leaderboard',
    small_desktop: 'billboard',
    large_desktop: 'billboard'
  },

  // three up package
  three_up_package: 'medium_rectangle',

  // search
  search_side: {
    small_desktop: ['medium_rectangle', 'half_page'],
    large_desktop: ['medium_rectangle', 'half_page']
  },
  search_grid: 'medium_rectangle',

  vertical_slideshow: {
    mobile: ['mobile_static_banner', 'medium_rectangle', 'unknown_name_300x50'],
    tablet: ['mobile_static_banner', 'medium_rectangle', 'unknown_name_300x50'],
    small_desktop: 'medium_rectangle',
    large_desktop: 'medium_rectangle'
  },

  teads_tablet_and_desktop: {
    small_desktop: 'teads',
    large_desktop: 'teads',
    tablet: 'teads'
  },

  teads_mobile: {
    mobile: 'teads'
  }
});
